// Material UI
import { makeStyles } from '@material-ui/core/styles'
// Consts
import Colors from '../../../../../constants/Colors'

export default makeStyles(theme => ({
  optionContainer: {
    display: 'flex',
    margin: '0 0 0 0 ',
    alignItems: 'flex-start',
    border: '1px solid',
    borderColor: Colors.BACKGROUND_ALTERNATIVE_COLOR,
    borderRadius: 8,
    padding: '8px 0 8px 12px',
  },
  optionContainerActive: {
    borderColor: Colors.PRIMARY_COLOR,
  },
  optionsContainer: {
    display: 'flex',
    gap: 8,
  },
  optionTitle: {
    padding: '10px 8px 8px 0px',
    margin: 0,
    fontWeight: 600,
    fontSize: 14,
  },
  optionDescription: {
    padding: '0px 16px 16px 0px',
    margin: 0,
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '20px',
  },
  radio: {
    '&$checked': {
      color: Colors.PRIMARY_COLOR,
    },
  },
  checked: {},
}))
